<template>
  <div class="modal fade" :class="{ show: isVisible }" tabindex="-1" aria-labelledby="exampleModalLabel"
    style="display: block" aria-modal="true" role="dialog" v-if="isVisible">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" @click="closeModal">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-3">
                <div class="form-wrap">
                  <label class="col-form-label">Lookup Type</label>
                  <Field as="select" name="lookup_type" class="form-select" v-model="selectedLookupType"
                    @change="updateSearchBy">
                    <!-- <option value="">-----Select-----</option> -->
                    <option v-for="res in lookupTypes" :key="res.value" :value="res.value">
                      {{ res.text }}
                    </option>
                  </Field>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-wrap">
                  <label class="col-form-label">Search By</label>
                  <Field as="select" name="search_by" class="form-select" v-model="selectedSearchBy">
                    <!-- <option value="">-----Select-----</option> -->
                    <option v-for="option in filteredSearchBy" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </Field>
                </div>
              </div>
              <div class="col-md-3" v-if="selectedSearchBy === 'company_name_postcode'">
                <div class="form-wrap">
                  <label class="col-form-label">Name</label>
                  <Field as="input" name="company_name" class="form-control" v-model="companyName" />
                </div>
              </div>
              <div class="col-md-3" v-if="selectedSearchBy === 'company_name_postcode'">
                <div class="form-wrap">
                  <label class="col-form-label">Postcode</label>
                  <Field as="input" name="postcode" class="form-control" v-model="localPostcode" />
                </div>
              </div>
              <div class="col-md-3" v-if="selectedSearchBy !== 'company_name_postcode'">
                <div class="form-wrap" :class="isNotValid ? 'mb-0' : ''">
                  <label class="col-form-label">{{ dynamicLabel }}</label>
                  <Field as="input" name="postcode" class="form-control" v-model="localPostcode" />
                </div>
                <span class="text-danger" v-if="isNotValid">{{ dynamicLabel }} is required</span>
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-6"></div>
              <div class="col-md-3 text-end">
                <button class="btn btn-primary" @click="handleSearch()">
                  Search
                </button>
              </div>
            </div>
            <div class="row mt-3 border-top pt-3" v-if="!searchCompany && gaspostcodeSearchResults?.length > 0">
              <div class="col-md-12">
                <div class="table-responsive table_height">
                  <table class="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" class="bg-teal text-white">
                          Full Address
                        </th>
                        <th scope="col" class="bg-teal text-white text-center">
                          Electric Meters
                        </th>
                        <th scope="col" class="bg-teal text-white text-center">
                          Gas Meters
                        </th>
                        <th scope="col" class="bg-teal text-white"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="res in gaspostcodeSearchResults" :key="res">
                        <td>{{ res.fullAddress }}</td>
                        <td class="text-center">{{ res.matchedElectricity ? 1 : 0 }}</td>
                        <td class="text-center">{{ res.matchedGas ? 1 : 0 }}</td>
                        <td>
                          <button class="btn btn-teal text-end" @click="getCompanyDetails(res.propertyAddressId)">
                            Look Up
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row mt-3 border-top pt-3" v-if="!searchCompany && elecpostcodeSearchResults?.length > 0">
              <div class="col-md-12">
                <div class="table-responsive table_height">
                  <table class="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" class="bg-teal text-white">
                          Full Address
                        </th>
                        <!-- <th scope="col" class="bg-teal text-white text-center">
                          Mpan
                        </th> -->
                        <th scope="col" class="bg-teal text-white">
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="res in elecpostcodeSearchResults" :key="res">
                        <td>{{ res?.address }}</td>
                        <!-- <td class="text-center">{{ res.mpan }}</td> -->

                        <td>
                          <button class="btn btn-teal text-end" @click="getElecDetails(res.mpan)">
                            Look Up
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row mt-3 border-top pt-3 justify-content-center align-items-center"
              v-if="searchCompany && !hasData">
              <div class="col-md-1">
                <button class="btn btn-primary" @click="backSearch">
                  <i class="ti ti-arrow-narrow-left"></i>
                </button>
              </div>
              <div class="col-md-11 text-center">
                <h5>{{ electricInfos[0]?.fullAddress }}</h5>
              </div>
              <div class="col-md-12">
                <div class="contact-tab-wrap mb-0 px-2">
                  <ul class="contact-nav nav">
                    <li class="col-md-2 me-0">
                      <a id="gas-tab" href="javascript:;" data-bs-toggle="tab" data-bs-target="#gasInfo"
                        class="active">Gas</a>
                    </li>
                    <li class="col-md-2 me-0">
                      <a id="electricity-tab" href="javascript:;" data-bs-toggle="tab"
                        data-bs-target="#electricityInfo">Electricity</a>
                    </li>
                  </ul>
                </div>

                <!-- Tab Content -->
                <div class="contact-tab-view mb-0 p-2">
                  <div class="tab-content pt-0">
                    <!-- gas -->
                    <div class="tab-pane active show" id="gasInfo">
                      <table class="table table-hover table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" class="bg-teal text-white">MPR</th>
                            <th scope="col" class="bg-teal text-white text-center">
                              Serial Number
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              IGT
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              Region
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="gasInfos.length > 0" class="row_click" @click="handleClick('gasInfos')">
                            <!-- @click="handleGasClick(gasInfos)" -->
                            <td>{{ gasInfos[0]?.mprn }}</td>
                            <td class="text-center">
                              {{ gasInfos[0]?.meterSerialNumber }}
                            </td>
                            <td class="text-center"></td>
                            <td class="text-center">
                              {{ gasInfos[0]?.address?.[0]?.town }}
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="4" class="text-center">
                              No Data Found
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="d-flex justify-content-end mt-3" v-if="gasInfos.length > 0">
                        <button type="button" class="btn btn-outline-dark"
                          @click="handleGasClick(gasInfos)">Copy</button>
                      </div>

                      <div v-if="gasInfoClick">
                        <table class="table table-bordered mt-2">
                          <tbody>
                            <!-- Render normal fields -->
                            <tr v-for="(value, key) in gasInfos[0]" :key="key">
                              <td v-if="key !== 'address'"><strong>{{ formatLabel(key) }}</strong></td>
                              <td v-if="key !== 'address'">{{ value }}</td>
                            </tr>

                            <!-- Address fields -->
                            <tr v-if="gasInfos[0]?.address?.length > 0">
                              <td colspan="2"><strong>Address</strong></td>
                            </tr>
                            <tr v-for="(value, key) in gasInfos[0]?.address?.[0]" :key="'address-' + key">
                              <td><strong>{{ formatLabel(key) }}</strong></td>
                              <td>{{ value }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>

                    <!-- electricity -->
                    <div class="tab-pane fade table-responsive" id="electricityInfo">
                      <table class="table table-hover table-responsive table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" class="bg-teal text-white">
                              MPAN Top
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              MPAN Bottom
                            </th>
                            <!-- <th scope="col" class="bg-teal text-white text-center">
                              Serial Number
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Measurement Class
                            </th>
                            <th scope="col" class="bg-teal text-white">AMR</th> -->
                            <th scope="col" class="bg-teal text-white text-center">
                              Meter Type
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              SSC
                            </th>
                            <!-- <th scope="col" class="bg-teal text-white">
                              De-Energised
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Related
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              Key Meter
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              Domestic
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Region
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              GSP
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Green Electric Deal
                            </th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="electricInfos.length > 0" @click="handleElecData('electricInfos')">
                            <!-- @click="handleElec(electricInfos)" -->
                            <td class="text-center">{{ mpanTop }}</td>
                            <td>{{ electricInfos[0]?.mpan }}</td>
                            <!-- <td class="text-center"></td>
                            <td></td>
                            <td></td> -->
                            <td class="text-center">
                              {{ electricInfos[0]?.meters?.[0]?.meterType }}
                            </td>
                            <td class="text-center">
                              {{ electricInfos[0]?.ssc }}
                            </td>
                            <!-- <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td> -->
                          </tr>
                          <tr v-else>
                            <td colspan="4" class="text-center">
                              No Data Found
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="d-flex justify-content-end mt-3" v-if="electricInfos.length > 0">
                        <button type="button" class="btn btn-outline-dark"
                          @click.prevent="(postcodeSearchIsPowwr && rawElectricMetersPowwr?.length) ? handleElecPowwr(rawElectricMetersPowwr[0]) : handleElec(electricInfos)">Copy</button>
                      </div>

                      <div v-if="elecInfoClick">
                        <!--  Main Table -->
                        <table class="table table-bordered mt-2">
                          <tbody>
                            <!-- Render normal fields (excluding meters & addressBreakdown) -->
                            <tr v-for="(value, key) in filteredElectricData" :key="key">
                              <td><strong>{{ formatLabel(key) }}</strong></td>
                              <td>{{ value }}</td>
                            </tr>

                            <!--  Address Breakdown Section -->
                            <tr v-if="electricInfos[0].addressBreakdown.length > 0">
                              <td colspan="2"><strong>Address</strong></td>
                            </tr>
                            <tr v-for="(value, index) in electricInfos[0].addressBreakdown" :key="'address-' + index"
                              v-if="value">
                              <td><strong>Part {{ index + 1 }}</strong></td>
                              <td>{{ value }}</td>
                            </tr>
                          </tbody>
                        </table>

                        <!--  Separate Meter Table -->
                        <table class="table table-bordered mt-4" v-if="electricInfos[0].meters.length > 0"
                          v-for="(meter, index) in electricInfos[0].meters" :key="'meter-' + index">
                          <thead>
                            <tr>
                              <th colspan="2" class="text-center">Meter Details</th>
                            </tr>
                          </thead>
                          <tbody>

                            <tr v-for="(value, key) in meter" :key="'meter-' + key">
                              <td><strong>{{ formatLabel(key) }}</strong></td>
                              <td>{{ value }}</td>
                            </tr>

                          </tbody>
                        </table>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- /Tab Content -->
              </div>
            </div>
            <div class="row mt-3 border-top pt-3" v-if="Object.keys(gasMprnData || {}).length > 0">
              <div class="col-md-12 mb-1 text-center">
                <h5>{{ `${gasMprnData?.address?.[0].primaryName} ${gasMprnData?.address?.[0].street1}
                  ${gasMprnData?.address?.[0].locality1}
                  ${gasMprnData?.address?.[0].town} ${gasMprnData?.address?.[0].postcode}` }}</h5>
              </div>
              <div class="col-md-12 mb-3">
                <div class="contact-tab-wrap mb-0 px-2">
                  <ul class="contact-nav nav justify-content-center">
                    <li class="col-md-2 me-0">
                      <a href="javascript:;" class="active">Gas</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" class="bg-teal text-white">MPR</th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Serial Number
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        IGT
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Region
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="row_click" @click="handleClick('gas')">
                      <!-- @click="handleGasClick(gasMprnData)" -->
                      <td>{{ gasMprnData.mprn }}</td>
                      <td class="text-center">
                        {{ gasMprnData.meterSerialNumber }}
                      </td>
                      <td class="text-center"></td>
                      <td class="text-center">
                        {{ gasMprnData?.address?.[0].town }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-end mt-3">
                  <button type="button" class="btn btn-outline-dark" @click="handleGasClick(gasMprnData)">Copy</button>
                </div>

                <div v-if="gasClick">
                  <table class="table table-bordered mt-2">
                    <tbody>
                      <!-- Render normal fields -->
                      <tr v-for="(value, key) in gasMprnData" :key="key">
                        <td v-if="key !== 'address'"><strong>{{ formatLabel(key) }}</strong></td>
                        <td v-if="key !== 'address'">{{ value }}</td>
                      </tr>

                      <!-- Address fields -->
                      <tr v-if="gasMprnData?.address?.length > 0">
                        <td colspan="2"><strong>Address</strong></td>
                      </tr>
                      <tr v-for="(value, key) in gasMprnData?.address?.[0]" :key="'address-' + key">
                        <td><strong>{{ formatLabel(key) }}</strong></td>
                        <td>{{ value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

            <!-- <div v-if="hasData">
              <div class="col-md-12 mb-3">
                <div class="contact-tab-wrap mb-0 px-2">
                  <ul class="contact-nav nav justify-content-center">
                    <li class="col-md-2 me-0">
                      <a href="javascript:;" class="active">Gas</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <h3 class="text-center">No data found</h3>
              </div>

            </div> -->
            <div class="row mt-3 border-top pt-3" v-if="hasData && searchCompany">
              <div class="col-md-1">
                <button class="btn btn-primary" @click="backSearch">
                  <i class="ti ti-arrow-narrow-left"></i>
                </button>
              </div>
              <!-- <div class="col-md-12 mb-3">
                <h5 class="text-center">{{ electricData?.fullAddress }}</h5>
              </div> -->
              <div class="col-md-12 mb-3">
                <div class="contact-tab-wrap mb-0 px-2">
                  <ul class="contact-nav nav justify-content-center">
                    <li class="col-md-2 me-0">
                      <a href="javascript:;" class="active">Electricity</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="table-responsive p-0">
                <!-- <table class="table table-hover table-responsive table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" class="bg-teal text-white">MPAN Top</th>
                      <th scope="col" class="bg-teal text-white text-center">
                        MPAN Bottom
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Serial Number
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Measurement Class
                      </th>
                      <th scope="col" class="bg-teal text-white">AMR</th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Meter Type
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        SSC
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        De-Energised
                      </th>
                      <th scope="col" class="bg-teal text-white">Related</th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Key Meter
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Domestic
                      </th>
                      <th scope="col" class="bg-teal text-white">Region</th>
                      <th scope="col" class="bg-teal text-white text-center">
                        GSP
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Green Electric Deal
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr @click="handleElecClick(electricData)">
                      <td class="text-center">{{ mpanTop }}</td>
                      <td>{{ electricData.mpan }}</td>
                      <td class="text-center"></td>
                      <td></td>
                      <td></td>
                      <td class="text-center">
                        {{ electricData.meters[0].meterType }}
                      </td>
                      <td class="text-center">{{ electricData.ssc }}</td>
                      <td class="text-center">{{ electricData.es }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table> -->
                <table class="table table-hover table-responsive table-bordered">
                  <thead>
                    <tr>
                      <!-- <th scope="col" class="bg-teal text-white">MPAN Top</th>
                        <th scope="col" class="bg-teal text-white text-center">
                          MPAN Bottom
                        </th> -->
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 1
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Address Line 2
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 3
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 4
                      </th>
                      <!-- <th scope="col" class="bg-teal text-white">
                        Address Line 5
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 6
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 7
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 8
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Address Line 9
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Post Code
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Supplier Name
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Supplier Effective Date
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Total Consumption
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr @click="handleElecData('electricData')">
                      <!-- @click="handleElecClick(electricData)" -->
                      <!-- <td class="text-center">{{ electricData.mpan }}</td>
                        <td>{{ electricData.mpan }}</td> -->
                      <td class="text-center">{{ electricData?.metering_point_address_line_1 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_2 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_3 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_4 }}</td>
                      <!-- <td class="text-center">{{ electricData?.metering_point_address_line_5 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_6 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_7 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_8 }}</td>
                      <td class="text-center">{{ electricData?.metering_point_address_line_9 }}</td>
                      <td class="text-center">{{ electricData.post_code }}</td>
                      <td class="text-center">{{ electricData.supplier_name }}</td>
                      <td class="text-center">{{ electricData.supplier_efd }}</td>
                      <td class="text-center">{{ electricData.total_eac }}</td> -->
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-end mt-3">
                  <button type="button" class="btn btn-outline-dark"
                    @click.prevent="handleElecClick(electricData)">Copy</button>
                </div>

                <div v-if="elecClick">
                  <table class="table table-bordered mt-2">
                    <tbody>
                      <!-- Render normal fields -->
                      <tr v-for="(value, key) in electricData" :key="key">
                        <td v-if="key !== 'additional_detail'"><strong>{{ formatLabel(key) }}</strong></td>
                        <td v-if="key !== 'additional_detail'">{{ value }}</td>
                      </tr>


                      <!-- Address fields -->
                      <tr v-if="electricData?.additional_detail?.length > 0">
                        <td colspan="2"><strong>Additional Details</strong></td>
                      </tr>
                      <tr v-for="(value, key) in electricData?.additional_detail?.[0]" :key="'address-' + key">
                        <td><strong>{{ formatLabel(key) }}</strong></td>
                        <td>{{ value }}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row mt-3 border-top pt-3" v-if="electricInfos.length > 0 && hasElectra">
              <div class="col-md-12 mb-3">
                <h5 class="text-center">{{ electricInfos?.[0]?.fullAddress }}</h5>
              </div>
              <div class="col-md-12 mb-3">
                <div class="contact-tab-wrap mb-0 px-2">
                  <ul class="contact-nav nav justify-content-center">
                    <li class="col-md-2 me-0">
                      <a href="javascript:;" class="active">Electricity</a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- electricity -->
              <table class="table table-hover table-responsive table-bordered">
                <thead>
                  <tr>
                    <th scope="col" class="bg-teal text-white">
                      MPAN Top
                    </th>
                    <th scope="col" class="bg-teal text-white text-center">
                      MPAN Bottom
                    </th>
                    <!-- <th scope="col" class="bg-teal text-white text-center">
                              Serial Number
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Measurement Class
                            </th>
                            <th scope="col" class="bg-teal text-white">AMR</th> -->
                    <th scope="col" class="bg-teal text-white text-center">
                      Meter Type
                    </th>
                    <th scope="col" class="bg-teal text-white text-center">
                      SSC
                    </th>
                    <!-- <th scope="col" class="bg-teal text-white">
                              De-Energised
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Related
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              Key Meter
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              Domestic
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Region
                            </th>
                            <th scope="col" class="bg-teal text-white text-center">
                              GSP
                            </th>
                            <th scope="col" class="bg-teal text-white">
                              Green Electric Deal
                            </th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="electricInfos.length > 0" @click="handleElecData('electricInfos')">
                    <!-- @click="handleElec(electricInfos)" -->
                    <td class="text-center">{{ mpanTop }}</td>
                    <td>{{ electricInfos[0]?.mpan }}</td>
                    <!-- <td class="text-center"></td>
                            <td></td>
                            <td></td> -->
                    <td class="text-center">
                      {{ electricInfos[0]?.meters?.[0]?.meterType }}
                    </td>
                    <td class="text-center">
                      {{ electricInfos[0]?.ssc }}
                    </td>
                    <!-- <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td> -->
                  </tr>
                  <tr v-else>
                    <td colspan="4" class="text-center">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-end mt-3" v-if="electricInfos.length > 0">
                  <button type="button" class="btn btn-outline-dark"
                    @click.prevent="(postcodeSearchIsPowwr && rawElectricMetersPowwr?.length) ? handleElecPowwr(rawElectricMetersPowwr[0]) : handleElec(electricInfos)">Copy</button>
              </div>

              <div v-if="elecInfoClick">
                <!--  Main Table -->
                <table class="table table-bordered mt-2">
                  <tbody>
                    <!-- Render normal fields (excluding meters & addressBreakdown) -->
                    <tr v-for="(value, key) in filteredElectricData" :key="key">
                      <td><strong>{{ formatLabel(key) }}</strong></td>
                      <td>{{ value }}</td>
                    </tr>

                    <!--  Address Breakdown Section -->
                    <tr v-if="electricInfos[0].addressBreakdown.length > 0">
                      <td colspan="2"><strong>Address</strong></td>
                    </tr>
                    <tr v-for="(value, index) in electricInfos[0].addressBreakdown" :key="'address-' + index"
                      v-if="value">
                      <td><strong>Part {{ index + 1 }}</strong></td>
                      <td>{{ value }}</td>
                    </tr>
                  </tbody>
                </table>

                <!--  Separate Meter Table -->
                <table class="table table-bordered mt-4" v-if="electricInfos[0].meters.length > 0"
                  v-for="(meter, index) in electricInfos[0].meters" :key="'meter-' + index">
                  <thead>
                    <tr>
                      <th colspan="2" class="text-center">Meter Details</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr v-for="(value, key) in meter" :key="'meter-' + key">
                      <td><strong>{{ formatLabel(key) }}</strong></td>
                      <td>{{ value }}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
  onUnmounted,
  computed,
  defineEmits
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
import {
  Form,
  Field,
  ErrorMessage
} from "vee-validate";
import { useToast } from "vue-toast-notification";

export default {
  props: {
    formData: {
      type: Array
    },
    supplierOptions: {
      type: Array
    },
    isVisible: {
      type: Boolean,
    },
    searchPostcode: {
      type: String,
      default: "",
    },
    selectedLabel: {
      type: String,
      default: "postcode",
    },
    fromOpp: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup(props, {
    emit
  }) {
    const store = useStore();
    const hasData = ref(false)
    const toast = useToast();
    const gasClick = ref(false)
    const gasInfoClick = ref(false)
    const elecClick = ref(false)
    const elecInfoClick = ref(false)
    const lookupTypes = ref([{
      value: "site_lookup",
      text: "Site Lookup",
    },
    /*{
      value: "company_lookup",
      text: "Company Lookup",
    }, */
    ]);

    // Search options based on lookup type
    const searchOptions = {
      company_lookup: [{
        value: "company_name",
        text: "Company Name",
      },
      {
        value: "company_number",
        text: "Company Number",
      },
      {
        value: "company_name_postcode",
        text: "Company Name and Postcode",
      },
      ],
      site_lookup: [{
        value: "postcode",
        text: "Postcode",
      },
      {
        value: "mpan",
        text: "MPAN bottom line",
      },
      {
        value: "mprn",
        text: "MPRN",
      },
      /* {
        value: "msn",
        text: "MSN",
      }, */
        // Add more options as needed for site lookup
      ],
    };
    const searchCompany = ref(false);
    const localPostcode = ref(props.searchPostcode);
    const selectedLookupType = ref(lookupTypes.value[0].value); // Default to the first lookup type
    const selectedSearchBy = ref(props.selectedLabel || ""); // Start empty, will be updated based on the lookup type
    const electricInfos = ref([]);
    const hasElectra = ref(false)
    const gasInfos = ref([]);
    const gaspostcodeSearchResults = ref([]);
    const elecpostcodeSearchResults = ref([]);
    const gasMprnData = ref([]);
    const electricData = ref([]);
    const mpanTop = ref('');
    const postcodeSearchIsPowwr = ref(false);
    const rawElectricMetersPowwr = ref([]);
    const rawGasMetersPowwr = ref([]);
    const isNotValid = ref(false);
    // Function to update search by selection based on the selected lookup type
    const updateSearchBy = () => {
      const options = searchOptions[selectedLookupType.value] || [];
      selectedSearchBy.value = options.length > 0 ? options[0].value : ""; // Select the first search option by default
    };

    // Watch for changes in selectedLookupType to update selectedSearchBy
    watch(selectedLookupType, (newValue) => {
      updateSearchBy(); // Update search options when lookup type changes
    });

    // Computed property to filter search options based on selected lookup type
    const filteredSearchBy = computed(() => {
      return searchOptions[selectedLookupType.value] || [];
    });

    const electra_link_set_opp = computed(
      () => store.getters["opportunity/getElectraLink"]
    );

    const electra_link_set_quote = computed(
      () => store.getters["price/getElectraLink"]
    );

    // Computed property to determine the dynamic label based on selected search type
    const dynamicLabel = computed(() => {
      if (selectedSearchBy.value === "company_name") {
        return "Company Name";
      } else if (selectedSearchBy.value === "company_number") {
        return "Company Number";
      } else if (selectedSearchBy.value === "company_name_postcode") {
        return "Company Name and Postcode";
      } else if (selectedSearchBy.value === "mpan") {
        return "MPAN bottom line";
      } else if (selectedSearchBy.value === "mprn") {
        return "MPRN";
      } else if (selectedSearchBy.value === "msn") {
        return "MSN";
      }
      return "Postcode"; // Default label
    });

    const closeModal = () => {
      hasData.value = false
      searchCompany.value = false;
      electricData.value = [];
      mpanTop.value = '';
      gasMprnData.value = [];
      electricInfos.value = [];
      gasInfos.value = [];
      gaspostcodeSearchResults.value = [];
      elecpostcodeSearchResults.value = [];
      gasClick.value = false;
      gasInfoClick.value = false;
      elecClick.value = false;
      elecInfoClick.value = false;
      hasElectra.value = true
      postcodeSearchIsPowwr.value = false;
      rawElectricMetersPowwr.value = [];
      rawGasMetersPowwr.value = [];
      emit("close"); // Now correctly using emit
    };
    // Watch for changes in `searchPostcode` prop and update `localPostcode`

    const handleElec = (electricData) => {
      // props.formData.mainProductService === 'elec';
      props.formData.main_production_service?.toLowerCase() === 'elec'
      // if (props.formData.mainProductService === 'elec' || props.formData.main_production_service?.toLowerCase() === 'elec') {
      if (props.fromOpp) {
        props.formData.supply_address.building_name = electricData?.[0]?.addressBreakdown?.[2] ?? electricData?.addressBreakdown?.[2];
        props.formData.supply_address.city = electricData?.[0]?.addressBreakdown?.[7] ?? electricData?.addressBreakdown?.[7];
        props.formData.supply_address.county = electricData?.[0]?.addressBreakdown?.[0] ?? electricData?.addressBreakdown?.[0];
        props.formData.supply_address.street = electricData?.[0]?.addressBreakdown?.[4] ?? electricData?.addressBreakdown?.[4];
        props.formData.supply_address.postcode = electricData?.[0]?.addressBreakdown?.[9] ?? electricData?.addressBreakdown?.[9];
        props.formData.mpan_top = electricData?.MPANTop ?? mpanTop.value;
        props.formData.mpan_bottom = electricData?.mpan ?? electricData?.[0].mpan;
        const supplier_id = findSupplierId(electricData?.currentSupplier ?? electricData?.[0]?.currentSupplier)
        props.formData.supplier_id = supplier_id;
        // props.formData.supplier_id = electricData?.current_supplier_name ?? electricData[0]?.current_supplier_name
      } else if (props.formData.mainProductService === 'elec') {
        props.formData.quoteDetails.ElectricSupply.MPANTop = electricData?.MPANTop ?? mpanTop.value;
        props.formData.quoteDetails.ElectricSupply.StandardSettlementConfig = electricData?.ssc ?? electricData?.[0]?.ssc;
        props.formData.quoteDetails.PostCode = electricData?.addressBreakdown?.[9] ?? electricData?.[0].addressBreakdown?.[9];
        props.formData.quoteDetails.ElectricSupply.MPANBottom = electricData?.mpan ?? electricData?.[0]?.mpan;
        props.formData.quoteDetails.CurrentSupplier = electricData?.currentSupplier ?? electricData?.[0]?.currentSupplier;
        props.formData.quoteDetails.ElectricSupply.MeterType = electricData?.[0]?.meters?.[0]?.meterType;
        props.formData.quoteDetails.ElectricSupply.MeasurementClass = electricData?.[0]?.measurmentClass;
      }
      // }
      closeModal()
    }

    /** Copy handler for Powwr postcode flow – same field mapping as electricLookup handleElecClickPowwr. */
    const handleElecPowwr = (rawPowwrMeter) => {
      if (!rawPowwrMeter || typeof rawPowwrMeter !== 'object') return;
      const loc = rawPowwrMeter.meterPointLocation || {};
      const supplier = rawPowwrMeter.currentSupplier || {};
      const profileClass = String(rawPowwrMeter.profileClass ?? '').padStart(2, '0');
      const mtcId = String(rawPowwrMeter.meterTimeswitchClass ?? '').padStart(3, '0');
      const llf = String(rawPowwrMeter.lineLossFactor ?? '').slice(-3).padStart(3, '0').toLowerCase();
      const mpanTopVal = (rawPowwrMeter.standardSettlementConfiguration && rawPowwrMeter.standardSettlementConfiguration !== '') ? (profileClass + rawPowwrMeter.standardSettlementConfiguration + llf).toUpperCase() : (profileClass + mtcId + llf).toUpperCase();
      const supplierName = supplier.name ?? '';

      if (props.fromOpp) {
        props.formData.supply_address.building_name = [loc.addressLine3, loc.addressLine4].filter(Boolean).join(' ');
        props.formData.supply_address.city = loc.addressLine5 ?? '';
        props.formData.supply_address.county = loc.addressLine9 ?? '';
        props.formData.supply_address.street = loc.addressLine8 ?? '';
        props.formData.supply_address.postcode = loc.postCode ?? '';
        props.formData.mpan_bottom = rawPowwrMeter.mpan ?? '';
        const supplier_id = findSupplierId(supplierName);
        props.formData.supplier_id = supplier_id;
        props.formData.forecast_commission.sc_forecast_or_amended_annual_consumption = rawPowwrMeter.annualConsumption ?? '';
        props.formData.mpan_top = mpanTopVal;
      } else if (props.formData.mainProductService === 'elec') {
        props.formData.quoteDetails.ElectricSupply.StandardSettlementConfig = rawPowwrMeter.standardSettlementConfiguration ?? '';
        props.formData.quoteDetails.ElectricSupply.DayConsumption.Amount = rawPowwrMeter.annualConsumption ?? '';
        props.formData.quoteDetails.PostCode = loc.postCode ?? '';
        props.formData.quoteDetails.ElectricSupply.MPANBottom = rawPowwrMeter.mpan ?? '';
        props.formData.quoteDetails.CurrentSupplier = supplierName;
        props.formData.quoteDetails.ElectricSupply.MeterType = rawPowwrMeter.meterType ?? '';
        props.formData.quoteDetails.ElectricSupply.MeasurementClass = rawPowwrMeter.measurementClass ?? '';
        props.formData.quoteDetails.ElectricSupply.MPANTop = mpanTopVal;
        props.formData.quoteDetails.ProfileClass = rawPowwrMeter.profileClass ?? '';
        props.formData.quoteDetails.LineLossFactorClass = rawPowwrMeter.lineLossFactor ? (String(rawPowwrMeter.lineLossFactor).length <= 3 ? '0' + rawPowwrMeter.lineLossFactor : rawPowwrMeter.lineLossFactor) : '';
        props.formData.quoteDetails.MhhsMigrated = rawPowwrMeter.mhhsIndicator ?? '';
        props.formData.quoteDetails.DuosTariffId = rawPowwrMeter.duosTariffId ?? '';
        props.formData.quoteDetails.MeterTimeswitchClass = rawPowwrMeter.meterTimeswitchClass ?? '';
        if (props.formData.quoteDetails.Settings && props.formData.quoteDetails.Settings[1]) {
          props.formData.quoteDetails.Settings[1].value = 50;
        }
      }
      closeModal();
    };

    const handleElecClick = (electricData) => {
      // props.formData.mainProductService === 'elec';
      props.formData.main_production_service?.toLowerCase() === 'elec'
      // if (props.formData.mainProductService === 'elec' || props.formData.main_production_service?.toLowerCase() === 'elec') {
      if (props.fromOpp) {
        props.formData.supply_address.building_name = electricData?.metering_point_address_line_3 + ' ' + electricData?.metering_point_address_line_4;
        props.formData.supply_address.city = electricData?.metering_point_address_line_5;
        props.formData.supply_address.county = electricData?.metering_point_address_line_9;
        props.formData.supply_address.street = electricData?.metering_point_address_line_8;
        props.formData.supply_address.postcode = electricData?.post_code;
        props.formData.mpan_bottom = electricData.mpan;
        const supplier_id = findSupplierId(electricData?.supplier_name)
        props.formData.supplier_id = supplier_id;
        props.formData.forecast_commission.sc_forecast_or_amended_annual_consumption = electricData?.total_eac;
        // props.formData.mpan_top = electricData?.total_eac;

        const profileClass = String(electricData?.additional_detail?.[0].profile_class || '')
          .padStart(2, '0');

        const mtcId = String(electricData?.additional_detail?.[0].mtc_id || '')
          .padStart(3, '0');

        const llf = String(electricData?.line_loss_factor_class_id || '')
          .slice(-3) // get last 3 chars
          .padStart(3, '0') // ensure length 3
          .toLowerCase();

        props.formData.mpan_top = (profileClass + mtcId + llf).toUpperCase();

      } else if (props.formData.mainProductService === 'elec') {
        props.formData.quoteDetails.ElectricSupply.DayConsumption.Amount = electricData?.total_eac;
        props.formData.quoteDetails.PostCode = electricData?.post_code;
        props.formData.quoteDetails.ElectricSupply.MPANBottom = electricData?.mpan;
        props.formData.quoteDetails.CurrentSupplier = electricData?.supplier_name;
        props.formData.quoteDetails.ElectricSupply.MeterType = electricData?.additional_detail?.[0].meter_type;
        props.formData.quoteDetails.ElectricSupply.MeasurementClass = electricData?.additional_detail?.[0].measurement_class;

        const profileClass = String(electricData?.additional_detail?.[0].profile_class || '')
          .padStart(2, '0');

        const mtcId = String(electricData?.additional_detail?.[0].mtc_id || '')
          .padStart(3, '0');

        const llf = String(electricData?.line_loss_factor_class_id || '')
          .slice(-3) // get last 3 chars
          .padStart(3, '0') // ensure length 3
          .toLowerCase();

        props.formData.quoteDetails.ElectricSupply.MPANTop = (profileClass + mtcId + llf).toUpperCase();

      }
      // }
      closeModal()
    }

    const handleGasClick = (gasMprnData) => {
      // props.formData.mainProductService === 'gas';
      props.formData.main_production_service?.toLowerCase() === 'gas';
      // if (props.formData.mainProductService === 'gas' || props.formData.main_production_service?.toLowerCase() === 'gas') {
      if (props.fromOpp) {
        props.formData.mpr = gasMprnData?.mprn ?? gasMprnData?.[0]?.mprn
        const supplier_id = findSupplierId(gasMprnData?.current_supplier_name ?? gasMprnData?.[0]?.current_supplier_name)
        props.formData.supplier_id = supplier_id;
        // props.formData.supplier_id = gasMprnData?.currentSupplierId ?? gasMprnData?.[0]?.current_supplier_name
        props.formData.supply_address.building_name = gasMprnData.address?.[0].primaryName ?? gasMprnData?.[0]?.address?.[0]?.primaryName;
        props.formData.supply_address.city = gasMprnData.address?.[0].town ?? gasMprnData?.[0]?.address?.[0]?.town;
        props.formData.supply_address.county = gasMprnData.address?.[0].locality1 ?? gasMprnData?.[0]?.address?.[0]?.locality1;
        props.formData.supply_address.postcode = gasMprnData.address?.[0].postcode ?? gasMprnData?.[0]?.address?.[0]?.postcode;
        props.formData.supply_address.street = gasMprnData.address?.[0].street1 ?? gasMprnData?.[0]?.address?.[0]?.street1;
        props.formData.forecast_commission.sc_forecast_or_amended_annual_consumption = gasMprnData?.mpaq ?? gasMprnData?.[0]?.mpaq;
      } else if (props.formData.mainProductService === 'gas') {
        props.formData.quoteDetails.GasSupply.MPR = gasMprnData?.mprn ?? gasMprnData?.[0]?.mprn;
        props.formData.quoteDetails.PostCode = gasMprnData?.address?.[0]?.postcode ?? gasMprnData?.[0]?.address?.[0]?.postcode;
        props.formData.quoteDetails.CurrentSupplier = gasMprnData?.current_supplier_name ?? gasMprnData?.[0]?.current_supplier_name;
        props.formData.quoteDetails.GasSupply.Consumption.Amount = gasMprnData?.mpaq ?? gasMprnData?.[0]?.mpaq;
      }
      // }
      closeModal()
    }

    const findSupplierId = (supplierName) => {
      if (!supplierName || !props.supplierOptions) return null;

      const inputName = supplierName.toLowerCase();

      // 1. Try exact match using `includes()`
      let bestMatch = props.supplierOptions.find(option =>
        option.text.toLowerCase().includes(inputName)
      );

      // 2. If no match, try checking the first two words of `inputName`
      if (!bestMatch) {
        const firstTwoWords = inputName.split(" ").slice(0, 2).join(" ");

        bestMatch = props.supplierOptions.find(option =>
          option.text.toLowerCase().includes(firstTwoWords)
        );
      }

      return bestMatch ? bestMatch.id : null;
    };

    // watch(
    //   () => props.searchPostcode,
    //   (newPostcode) => {
    //     localPostcode.value = newPostcode;
    //   }
    // );
    // watch(
    //   () => props.selectedLabel,
    //   (newLabel) => {
    //     if (newLabel.toLowerCase() === "mprn") {
    //       props.selectedLabel = "mprn"
    //       selectedSearchBy.value = "mprn"; // Set MPRN as the default search by
    //     } else if (newLabel.toLowerCase() === "postcode") {
    //       props.selectedLabel = "postcode"
    //       selectedSearchBy.value = "postcode"; // Set MPRN as the default search by
    //     } else if (newLabel.toLowerCase() === "mpan") {
    //       props.selectedLabel = "mpan"
    //       selectedSearchBy.value = "mpan";
    //     } else {
    //       props.selectedLabel = "postcode"
    //       selectedSearchBy.value = "postcode";
    //     }
    //     // Add more conditions for other selectedLabel if needed
    //   }, {
    //   immediate: true,
    // }
    // );

    watch(() => props.isVisible,
      () => {
        localPostcode.value = props.searchPostcode;
      },
      {
        immediate: true,
      }
    );
    watch(() => props.isVisible,
      () => {
        if (props.selectedLabel.toLowerCase() === "mprn") {
          selectedSearchBy.value = "mprn"; // Set MPRN as the default search by
        } else if (props.selectedLabel.toLowerCase() === "postcode") {
          selectedSearchBy.value = "postcode"; // Set MPRN as the default search by
        } else if (props.selectedLabel.toLowerCase() === "mpan") {
          selectedSearchBy.value = "mpan";
        } else if (props.selectedLabel.toLowerCase() === "msn") {
          selectedSearchBy.value = "msn";
        } else {
          selectedSearchBy.value = "postcode";
        }
        // Add more conditions for other selectedLabel if needed
      }, {
      immediate: true,
    }
    );

    // Watch for changes in visibility to apply or remove the backdrop
    watch(
      () => props.isVisible,
      (newValue) => {
        const backdropClass = "modal-backdrop";
        if (newValue) {
          // Modal is opened
          document.body.classList.add("modal-open");
          const backdrop = document.createElement("div");
          backdrop.className = `${backdropClass} fade show`;
          document.body.appendChild(backdrop);
        } else {
          // Modal is closed
          document.body.classList.remove("modal-open");
          const backdrop = document.querySelector(`.${backdropClass}`);
          if (backdrop) {
            backdrop.remove();
          }
        }
      }
    );

    // Cleanup on component unmount
    onUnmounted(() => {
      document.body.classList.remove("modal-open");
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }
    });

    const handleSearch = async () => {
      if (localPostcode.value === '') {
        isNotValid.value = true;
        return;
      } else {
        hasData.value = false
        searchCompany.value = false;
        electricData.value = [];
        mpanTop.value = '';
        gasMprnData.value = [];
        electricInfos.value = [];
        gasInfos.value = [];
        gaspostcodeSearchResults.value = [];
        elecpostcodeSearchResults.value = [];
        gasClick.value = false;
        gasInfoClick.value = false;
        elecClick.value = false;
        elecInfoClick.value = false;
        isNotValid.value = false;
        hasElectra.value = false
        postcodeSearchIsPowwr.value = false

        // Powwr API for Search By = MPAN bottom line, MPRN, or Postcode (existing flow unchanged for other types)
        if (selectedSearchBy.value === 'postcode') {
          try {
            const list = await store.dispatch('price/fetchPowwrAddressSearch', localPostcode.value);
            if (list && Array.isArray(list)) {
              gaspostcodeSearchResults.value = list;
              postcodeSearchIsPowwr.value = true;
            }
          } catch (err) {
            // Error already shown by store action
          }
          return;
        }
        if (selectedSearchBy.value === 'mpan') {
          try {
            const response = await store.dispatch('price/fetchPowwrMpanSearch', localPostcode.value);
            if (response && response.mapped !== undefined) {
              hasData.value = true;
              searchCompany.value = true;
              electricData.value = response.mapped;
            }
          } catch (err) {
            // Error already shown by store action
          }
          return;
        }
        if (selectedSearchBy.value === 'mprn') {
          try {
            const response = await store.dispatch('price/fetchPowwrMprnSearch', localPostcode.value);
            if (response && response.mapped !== undefined) {
              gasMprnData.value = response.mapped;
            }
          } catch (err) {
            // Error already shown by store action
          }
          return;
        }

        const paramsData = {
          search_type: selectedSearchBy.value, // Pass selected search type
          search_value: localPostcode.value,
          main_production_service: props.formData.main_production_service || props.formData.mainProductService,
          electra_link_set: electra_link_set_opp.value || electra_link_set_quote.value
        };
        // Dispatch the Vuex action with paramsData
        const response = await store.dispatch(
          "price/fetchLookupData",
          paramsData
        );
        searchCompany.value = false;
        if (response) {
          if (selectedSearchBy.value === "mprn" || (selectedSearchBy.value === "msn" && (props.formData.main_production_service === 'gas' || props.formData.mainProductService === 'gas')) ) {
            gasMprnData.value = response?.[0];
          } else if (selectedSearchBy.value === "mpan" && (electra_link_set_opp.value || electra_link_set_quote.value)) {
            hasData.value = true
            searchCompany.value = true;
            electricData.value = response;
            // mpanTop.value = electricData?.value.pc + electricData?.value.mtc + electricData?.value.llf;
            // electricData.value = { ...electricData.value, MPANTop: mpanTop.value }
          } else if (selectedSearchBy.value === "mpan" && (!electra_link_set_opp.value || !electra_link_set_quote.value)) {
            hasElectra.value = true
            electricInfos.value = response;
            mpanTop.value = electricInfos.value[0]?.pc + electricInfos.value[0]?.mtc + electricInfos.value[0]?.llf;
            electricInfos.value = [{ ...electricInfos.value[0], MPANTop: mpanTop.value }]
          }
          else if (selectedSearchBy.value === "postcode" && (electra_link_set_opp.value || electra_link_set_quote.value) && (props.formData.main_production_service === 'elec' || props.formData.mainProductService === 'elec')) {
            elecpostcodeSearchResults.value = response;
          } else if (selectedSearchBy.value === "msn" && (props.formData.main_production_service === 'elec' || props.formData.mainProductService === 'elec'))  {
            hasElectra.value = true
            electricInfos.value = response;
            mpanTop.value = electricInfos.value[0]?.pc + electricInfos.value[0]?.mtc + electricInfos.value[0]?.llf;
            electricInfos.value = [{ ...electricInfos.value[0], MPANTop: mpanTop.value }]
          } else {
            gaspostcodeSearchResults.value = response;
          }
        }
      }
      // else if(paramsData.search_type === 'mprn' || (paramsData.search_type === 'postcode' && main_product_service === 'gas')) {
    };

    const getCompanyDetails = async (id) => {
      if (postcodeSearchIsPowwr.value) {
        try {
          const response = await store.dispatch('price/fetchPowwrMeterAddressIdSearch', id);
          if (response?.status && response?.data) {
            searchCompany.value = true;
            electricInfos.value = response.data.elecInfo ?? [];
            gasInfos.value = response.data.gasInfo ?? [];
            rawElectricMetersPowwr.value = response.raw?.electricMeters ?? [];
            rawGasMetersPowwr.value = response.raw?.gasMeters ?? [];
            const firstElec = response.data.elecInfo?.[0];
            mpanTop.value = firstElec ? (firstElec.pc + firstElec.mtc + firstElec.llf) : '';
          } else {
            toast.error(response?.message || 'Failed to load meter details');
          }
        } catch (err) {
          // Error already shown by store action
        }
        return;
      }
      const paramsData = {
        addressId: id, // Pass selected search type
        //   // U100020699213A0088278720G1M1900020113468N1PCR76EP
      };
      const response = await store.dispatch(
        "price/fetchSearchPropertyData",
        paramsData
      );
      if (response?.status) {
        searchCompany.value = true;
        electricInfos.value = response.data?.elecInfo;
        gasInfos.value = response.data?.gasInfo;
        mpanTop.value = response.data?.elecInfo[0]?.pc + response.data?.elecInfo[0]?.mtc + response.data?.elecInfo[0]?.llf;
      }
      else {
        toast.error(response.message)
      }
    };

    const getElecDetails = async (mpan) => {
      const paramsData = {
        mpan: mpan,
      };
      const response = await store.dispatch(
        "price/fetchMpanAdditionalInfo",
        paramsData
      );
      if (response?.status) {
        searchCompany.value = true;
        hasData.value = true;
        // electricInfos.value = response.data?.elecInfo;
        // gasInfos.value = response.data?.gasInfo;
        // mpanTop.value = response.data?.elecInfo[0]?.pc + response.data?.elecInfo[0]?.mtc + response.data?.elecInfo[0]?.llf;
        electricData.value = response.data;
      }
      else {
        toast.error(response.message)
      }
    };

    const backSearch = async () => {
      searchCompany.value = false;
      const gasTab = document.querySelector('#gas-tab');
      const elecTab = document.querySelector('#electricity-tab');

      if (elecTab) elecTab.classList.remove('active');
      if (gasTab) {
        gasTab.classList.add('active');
      }
    };

    // ✅ Computed property to exclude `addressBreakdown` and `meters`
    const filteredElectricData = computed(() => {
      const { addressBreakdown, meters, ...filteredData } = electricInfos.value[0]; // Exclude nested fields
      return filteredData;
    });

    const handleClick = (input) => {
      if (input === 'gas') {
        gasClick.value = !gasClick.value;
      } else {
        gasInfoClick.value = !gasInfoClick.value;
      }
    }

    const handleElecData = (input) => {
      if (input === 'electricInfos') {
        elecInfoClick.value = !elecInfoClick.value;
      } else {
        elecClick.value = !elecClick.value;
      }
    }

    // Function to format labels (replaces underscores with spaces and capitalizes)
    const formatLabel = (key) => {
      return key
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
    };

    // Initialize search options on component mount
    onMounted(() => {
      updateSearchBy();
    });

    return {
      mpanTop,
      electricData,
      gasMprnData,
      electricInfos,
      gasInfos,
      backSearch,
      searchCompany,
      getCompanyDetails,
      gaspostcodeSearchResults,
      elecpostcodeSearchResults,
      postcodeSearchIsPowwr,
      rawElectricMetersPowwr,
      handleElecPowwr,
      store,
      handleSearch,
      localPostcode,
      isNotValid,
      lookupTypes,
      closeModal,
      selectedSearchBy,
      dynamicLabel,
      searchOptions,
      selectedLookupType,
      filteredSearchBy,
      updateSearchBy, // Expose this method if needed
      handleElecClick,
      handleGasClick,
      hasData,
      handleElec,
      handleClick,
      gasClick,
      gasInfoClick,
      elecClick,
      elecInfoClick,
      formatLabel,
      handleElecData,
      filteredElectricData,
      getElecDetails,
      findSupplierId,
      electra_link_set_opp,
      electra_link_set_quote,
      hasElectra
    };
  },
};
</script>

<style scoped>
.modal {
  display: block;
  /* Ensure modal is displayed correctly */
}

.row_click {
  cursor: pointer;
}

.table_height {
  max-height: 428px;
}
</style>
